import { render, staticRenderFns } from "./SiteVolunteerManagement.vue?vue&type=template&id=a0e23d2c"
import script from "./SiteVolunteerManagement.vue?vue&type=script&lang=ts"
export * from "./SiteVolunteerManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports